import { Avatar as AntdAvatar } from "antd";

import { AvatarSize, BaseAvatarProps } from "./types";

import BaseTooltip from "../Tooltip/BaseTooltip";

const AVATAR_SIZES: Record<AvatarSize, number> = {
  small: 24,
  default: 32,
  large: 40,
  "extra-large": 48,
};

const BaseAvatar = ({
  label,
  imageUrl,
  link,
  onClick,
  tooltip,
  size = "large",
  className,
  ...props
}: BaseAvatarProps) => {
  const avatarSize = AVATAR_SIZES[size];

  const handleClick = () => {
    if (link) {
      window.location.href = link;
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <BaseTooltip title={tooltip} placement="top">
      <AntdAvatar
        onClick={handleClick}
        {...props}
        size={avatarSize}
        src={imageUrl}
        alt={label}
        className={`base-avatar ${className && className}`}
      >
        {label?.slice(0, 2).toUpperCase()}
      </AntdAvatar>
    </BaseTooltip>
  );
};

export default BaseAvatar;
